import React, { useCallback, useEffect, useMemo, useState } from "react";
import WelcomeDialog from "../../card/dashboardCard/WelcomeDialog";
import JobTable from "../../table/JobTable";
import { Link, useNavigate } from "react-router-dom";
import Spinner from "../../layout/loader/Spinner";
import { Tooltip as ReactTooltip } from "react-tooltip";
import axios from "axios";
import { USER_DETAILS } from "../../layout/Layout";
import { useAtom, atom } from "jotai";
import { BASE_URL_2 } from "../../../customHooks/config";
import { toast } from "react-toastify";
import UploadDialog, {
  USER_DETAILS_UPDATE_UPLOAD_DAILOG,
} from "../../section/JobSection/UploadDialog";
import JobTableScreen from "../../table/JobTableScreen";

const AllJobsForSignUp = () => {
  const [loading, setLoading] = useState(false);
  const [paginationData, setPaginationData] = useState({
    pageSize: 5,
    pageNumber: 1,
    next: false,
    previous: false,
    count: 0,
  });
  const [jobData, setJobData] = useState([]);
  const navigate = useNavigate();
  const [userDetails] = useAtom(USER_DETAILS);
  const [uploadDailog] = useAtom(USER_DETAILS_UPDATE_UPLOAD_DAILOG);
  let status = userDetails?.data?.user_details?.vendor_status;
  let fileValue = userDetails?.data?.user_details?.file;

  useEffect(() => {
    let pageNumber, pageSize;
    pageNumber = paginationData.pageNumber;
    pageSize = paginationData.pageSize;
    setLoading(true);
    let url = `${BASE_URL_2}job/vendor/all_vendor_job/?page=${pageNumber}&page_size=${pageSize}`;
    axios
      .get(url, { withCredentials: true })
      .then((res) => {
        setLoading(false);
        setJobData(res?.data?.data);
        setPaginationData({
          ...paginationData,
          count: res?.data?.data?.count,
          next: res?.data?.data?.next ? true : false,
          previous: res?.data?.data?.previous ? true : false,
        });
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.data?.error);
      });
  }, [
    paginationData?.pageNumber,
    paginationData?.pageSize,
    paginationData?.status,
    uploadDailog,
  ]);

  useEffect(() => {
    if (status === "ACCEPTED") navigate("/all-jobs/1")
  }, [status])

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleAccept = (a, b) => {
    if (status === "PENDING" && fileValue)
      toast.success("Your Profile is in Pending Stage");
    else handleClickOpen();
  };

  const newJobcolumns = useMemo(
    () => [
      {
        Header: "Job ID",
        width: 60,
        accessor: "job_id",
      },
      {
        Header: "Job Title",
        width: 150,
        accessor: "job_title",
        Cell: ({ row }) => (
          <>
            <Link
              style={{ color: "#2563EB", textDecoration: "underline" }}
              to={`/job-details/${row.original.job_id}`}
              state={{
                status: null,
                create_time: row.original.create_time,
                job_status: row.original.job_status,
              }}
            >
              <p data-tooltip-id={row.original.job_title}>
                {row.original.job_title.length > 30
                  ? row.original.job_title.slice(0, 30)
                  : row.original.job_title}{" "}
                {row.original.job_title.length > 30 ? "...." : ""}
              </p>
            </Link>
            <ReactTooltip
              id={row.original.job_title}
              place="right"
              content={row.original.job_title}
            />
          </>
        ),
        linkAccessor: "link",
      },
      {
        Header: "Company Name",
        width: 150,
        accessor: "company.company_name",
        Cell: ({ row }) => (
          <>
            <p data-tooltip-id={row.original.job_id}>
              {row.original.company.company_name.length > 30
                ? row.original.company.company_name.slice(0, 30)
                : row.original.company.company_name}{" "}
              {row.original.company.company_name.length > 30 ? "....." : ""}
            </p>
            <ReactTooltip
              id={row.original.job_id}
              place="right"
              content={row.original.company.company_name}
            />
          </>
        ),
      },
      {
        Header: "Job Type",
        width: 120,
        accessor: "job_type_name",
      },
      {
        Header: "Projected Earning",
        width: 120,
        accessor: "projected",
        Cell: ({ value }) => (value === null ? 0 : `₹ ${value?.toFixed(2)}`),
      },
      {
        Header: "CTC/Stipend",
        width: 130,
        accessor: (row) => {
          if (row.job_type_name === "Full Time Job") {
            const max = String(row.ctc_max);
            const max_1 = max[0];
            const max_2 = max[1] ?? 0;
            const min = String(row.ctc_min);
            const min_1 = min[0];
            const min_2 = min[1] ?? 0;

            return `₹ ${min_1}.${min_2} - ${max_1}.${max_2}  LPA`;
          } else {
            const stipend = row.stipend ?? 0.0;
            return `₹ ${stipend}`;
          }
        },
      },
      {
        Header: "Location",
        width: 120,
        accessor: (row) => {
          if (row.work_from_home) return "Work From Home";
          else return row.job_location;
        },
        Cell: ({ value, row }) => {
          if (value === "Work From Home")
            return (
              <div
                onClick={() =>
                  window.open(`/job-details/${row.original.job_id}`, "_blank")
                }
              >
                Work From Home
              </div>
            );
          else if (Array.isArray(value) && value.length === 1)
            return (
              <div
                onClick={() => navigate(`/job-details/${row.original.job_id}`)}
              >
                {value[0].city}
              </div>
            );
          else {
            return (
              <div
                onClick={() =>
                  window.open(`/job-details/${row.original.job_id}`, "_blank")
                }
              >
                {`${value[0].city} , ${value[1].city} + ${value.length > 2 ? value.length - 2 : ""
                  }`}
              </div>
            );
          }
        },
      },
      {
        Header: " Action",
        // accessor: "action",
        Cell: ({ row }) => {
          if (row.original.job_status === "OPEN")
            return (
              <div>
                <button
                  className=" h-[34px] px-3 mr-2 bg-[#0DA06A] rounded-md text-sm text-white "
                  onClick={() => handleAccept(status, fileValue)}
                >
                  Accept
                </button>
                {/* <button
                      onClick={() => {
                        // handleClickOpen(row.original);
                      }}
                      className=" h-[34px] px-3 border border-[#EF4444] rounded-md text-sm text-[#EF4444] "
                    >
                      Reject
                    </button> */}
              </div>
            );
          else
            return (
              <button
                // onClick={()=>{handleClickOpen(row.original)}}
                disabled={true}
                className=" h-[34px] px-3 border border-[#EF4444] rounded-md text-sm text-[#EF4444] "
              >
                Close
              </button>
            );
        },
      },
    ],
    [userDetails]
  );
  return (
    <div className="h-[100%]">
      <JobTableScreen
        columns={newJobcolumns}
        data={jobData?.results ?? []}
        paginationData={paginationData}
        setPaginationData={setPaginationData}
        tableWidth="w-full h-[92%]"
        pagination="pagination"
        loading={loading}
      />
      <UploadDialog
        open={open}
        setOpen={setOpen}
        handleClickOpen={handleClickOpen}
      />
      <WelcomeDialog />
    </div>
  );
};

export default AllJobsForSignUp;
